import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axiosInstance from './axiosConfig';
import { setToken } from './authStorage';

const AdminRoute = ({ children }) => {
  const [hasPermission, setHasPermission] = useState(null);

  useEffect(() => {
    const checkRole = async () => {
      try {
        const response = await axiosInstance.get(`/api/check-auth`);
        const { role, accessToken } = response.data;

        if (accessToken) {
          await setToken(accessToken);
        }

        if (role === 'admin' || role === 'superadmin') {
          setHasPermission(true);
        } else {
          setHasPermission(false);
        }
      } catch (error) {
        setHasPermission(false);
      }
    };
    checkRole();
  }, []);

  if (hasPermission === null) return <div>Cargando...</div>;

  return hasPermission ? children : <Navigate to="/" />;
};

export default AdminRoute;

